// Telemetry dev panel — streams the POST /telemetry events for review/QA. Not part of
// the participant view; gated behind the reviewer "Telemetry" toggle.

import type { TelemetryEvent } from "../telemetry";

export function TelemetryPanel({ events, onClear, onClose }: { events: TelemetryEvent[]; onClear: () => void; onClose: () => void }) {
  const view = [...events].slice(-40).reverse();
  return (
    <div className="lenspop" style={{ position: "fixed", right: 16, bottom: 16, zIndex: 60, width: 360, maxWidth: "calc(100vw - 32px)", maxHeight: "62vh", background: "#fff", border: "1px solid rgba(55,53,47,.14)", borderRadius: 8, boxShadow: "0 16px 44px rgba(15,15,15,.16)", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 9, padding: "11px 13px", borderBottom: "1px solid rgba(55,53,47,.1)", background: "#f7f6f3" }}>
        <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#37352f" }} />
        <span style={{ fontFamily: "'IBM Plex Mono',ui-monospace,monospace", fontSize: 11, color: "rgba(55,53,47,.7)", letterSpacing: ".02em", flex: 1 }}>POST /telemetry · {events.length} events</span>
        <button onClick={onClear} style={{ background: "#fff", border: "1px solid rgba(55,53,47,.16)", color: "rgba(55,53,47,.6)", fontSize: 10, borderRadius: 4, padding: "3px 7px", cursor: "pointer", fontFamily: "'IBM Plex Mono',ui-monospace,monospace" }}>clear</button>
        <button onClick={onClose} style={{ background: "none", border: "none", color: "rgba(55,53,47,.4)", fontSize: 16, cursor: "pointer", lineHeight: 1, padding: "0 2px" }}>×</button>
      </div>
      <div style={{ overflowY: "auto", padding: "8px 10px", fontFamily: "'IBM Plex Mono',ui-monospace,monospace", fontSize: 11, lineHeight: 1.5 }}>
        {view.length === 0 ? (
          <div style={{ color: "rgba(55,53,47,.4)", padding: "14px 4px" }}>Interact with the panels; events stream here.</div>
        ) : view.map((e, i) => {
          const d = new Date(e.ts);
          const muted = e.event === "scroll_depth";
          const ps = JSON.stringify(e.payload);
          return (
            <div key={e.ts + "_" + i} style={{ padding: "5px 7px", borderRadius: 4, background: "#f7f6f3", borderLeft: "2px solid rgba(55,53,47,.25)", marginBottom: 4 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <span style={{ color: "rgba(55,53,47,.4)" }}>{d.toLocaleTimeString("en-US", { hour12: false })}.{String(d.getMilliseconds()).padStart(3, "0")}</span>
                <span style={{ color: muted ? "rgba(55,53,47,.45)" : "#37352f", fontWeight: 600 }}>{e.event}</span>
              </div>
              {ps !== "{}" && <div style={{ color: "rgba(55,53,47,.5)", marginTop: 2, wordBreak: "break-all" }}>{ps}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
